export type Validation = string | undefined;

export const Validation = {
  validate(result: Validation) {
    if (result) {
      throw new Error(result);
    }
  },
  reduce(validations: Validation[]): Validation {
    return validations.find((validation) => validation);
  },
};
